import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { CounterDirective } from '../shared/counter.directive';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CodeInputComponent } from '@rogers/cdk/form';
import { Flow } from '../shared/global-state.service';

@Component({
  selector: 'dam-verify-user-form',
  templateUrl: './verify-user-form.component.html',
  standalone: false,
  //styleUrls: ['./verify-user-form.component.scss']
})
export class VerifyUserFormComponent implements OnInit, AfterViewInit {
  @Input() type: string;
  @Input() ctn: string;
  @Input() email: string;
  @Input() flow: Flow;
  @Input() verifyUserInProgress: boolean;
  @Input() apiErrorTranslationKey: string;
  @Input() track;
  @Input() inputTranslate: string;
  @Input() pendingAutoReg: boolean;
  @Input() isFido;
  @ViewChildren(CounterDirective) CounterDirective;
  @Output() onValueChange = new EventEmitter<number>();
  @Output() sendCodeByEmail = new EventEmitter();
  @Output() changeEmailAddress = new EventEmitter();
  @Output() liveChat = new EventEmitter();
  @Output() resendCode = new EventEmitter();
  @Output() verifyUser = new EventEmitter();
  @Output() resetErrors = new EventEmitter();
  @Output() editRecoveryNumber = new EventEmitter();
  @Output() skipClicked = new EventEmitter();
  @ViewChild('codeInputRef')
  codeInputRef: CodeInputComponent;
  counter: number;
  counterInitialValue: number;
  resendDisabled = true;
  otp = '';
  verifyUserForm: FormGroup;
  formSubmitted = false;
  resendCodeClick = false;
  maxResendAttempts = false;

  constructor() {}

  ngOnInit() {
    this.counterInitialValue = 60;
    this.verifyUserForm = new FormGroup(
      {
        otp: new FormControl('', [Validators.required])
      },
      { updateOn: 'submit' }
    );
  }
  ngAfterViewInit() {
    this.codeInputRef.inputContainersList.forEach((element, i) => {
      element.nativeElement
        .querySelector('input')
        .setAttribute(
          'title',
          this.inputTranslate.replace('VALUE', (i + 1).toString())
        );
    });
    this.codeInputRef.inputsList.first.nativeElement.focus();
  }

  onSubmit() {
    this.formSubmitted = true;
    this.resetErrorMessage();
    if (this.otpFieldIsInvalid) {
      this.codeInputRef.inputsList.first.nativeElement.focus();
      return;
    }
    this.verifyUser.emit(this.otp);
  }

  onCodeCompleted(code: string) {
    this.otp = code;
  }

  onCodeChanged() {
    this.reset();
  }

  onSendCodeByEmail() {
    this.resetErrorMessage();
    this.sendCodeByEmail.emit();
    this.resetCounter();
    this.codeInputRef.clear();
    this.formSubmitted = false;
    this.codeInputRef.inputsList.first.nativeElement.focus();
  }

  onLiveChat() {
    this.liveChat.emit();
  }

  onResendCode() {
    this.resendDisabled = true;
    this.resendCode.emit();
    this.resendCodeClick = true;
  }

  /* This function is triggered from the parent */
  resendResponse(reachedCodeResends: boolean) {
    this.codeInputRef.inputsList.first.nativeElement.focus();
    if (reachedCodeResends) {
      this.resendDisabled = true;
      this.maxResendAttempts = true;
    } else {
      this.resendCodeClick = false;
      this.resetCounter();
    }
  }

  /* This function is triggered from the parent */
  endCounter() {
    if (!this.maxResendAttempts) {
      this.CounterDirective.first.endTimer();
      this.resendDisabled = true;
    }
  }

  onCounterChange(e: number): void {
    this.counter = e;
    this.resendDisabled = true;
    if (this.counter === 0) {
      this.resendDisabled = false;
      this.onValueChange.emit(-1);
    }
  }

  onChangeEmailAddress() {
    /* This is for registration flow*/
    this.changeEmailAddress.emit();
  }

  resetCounter() {
    this.CounterDirective.first.startTimer();
    this.resendDisabled = true;
  }

  get otpFieldIsInvalid() {
    return this.otp.length !== 6;
  }

  private reset() {
    this.otp = '';
    this.formSubmitted = false;
  }
  resetErrorMessage() {
    if (this.apiErrorTranslationKey !== null) this.resetErrors.emit();
  }
  onEditRecoveryNumber() {
    this.editRecoveryNumber.emit();
  }
  onSkip() {
    this.skipClicked.emit();
  }

  showChangeEmailOption() {
    return (this.type === 'verifyEmail' && this.flow === Flow.Registration && this.pendingAutoReg) ||
      this.flow === Flow.ChangeUsername ||
      this.flow === Flow.ChangeUsernameByToken
  }
}
